import React from "react";
import Head from "next/head";
import Link from "next/link";
import {
	INVENTORY_BRANDS,
	INVENTORY_OVERVIEW,
	getBrandHref,
} from "./inventory-page-data";
import SeoJsonLd from "./jsonld/seo-jsonld";

export default function InventoryOverview({ linkLocale = "en" }) {
	const copy = INVENTORY_OVERVIEW[linkLocale] || INVENTORY_OVERVIEW.en;
	const ogLocale = linkLocale === "es" ? "es_ES" : "en";

	return (
		<section className="tu-inventory" lang={linkLocale}>
			<SeoJsonLd locale={linkLocale} pageId="inventory" />
			<Head>
				<meta charSet="UTF-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<link rel="shortcut icon" type="image/png" href="/images/tu-favicon.png" />
				<meta
					name="facebook-domain-verification"
					content="fzctnjbrtlybvytmamk8glkng9af7p"
				/>
				<title>{copy.pageTitle}</title>
				<meta name="description" content={copy.metaDescription} />
				<meta name="keywords" content={copy.metaKeywords} />
				<meta name="author" content="Edgar Lindo" />
				<meta property="og:locale" content={ogLocale} />
				<meta property="site_name" content="TU" />
				<meta property="og:title" content={copy.ogTitle} />
				<meta property="og:description" content={copy.ogDescription} />
				<meta
					property="og:image"
					content="https://www.tu.biz/oppictures/inventory.png"
				/>
				<meta property="og:url" content={copy.ogUrl} />
				<meta name="twitter:card" content="summary_large_image" />
				<meta name="twitter:creator" content="@MrEdgarLindo" />
				<meta name="twitter:title" content={copy.twitterTitle} />
				<meta name="twitter:description" content={copy.twitterDescription} />
				<meta
					name="twitter:image"
					content="https://www.tu.biz/oppictures/inventory.png"
				/>
			</Head>

			<div className="tu-container">
				<header className="tu-inventory__header">
					<h1 className="tu-inventory__title">{copy.title}</h1>
					<p className="tu-inventory__intro">
						{copy.introLead}{" "}
						<Link href={copy.contactHref}>{copy.contactUs}</Link> {copy.introTrail}
					</p>
				</header>

				<section className="tu-inventory__brands" aria-labelledby="tu-inventory-brands">
					<h2 id="tu-inventory-brands" className="tu-inventory__brands-title">
						{copy.brandsHeading}
					</h2>
					<p className="tu-inventory__brands-subtitle">{copy.brandsSubtitle}</p>
					<ul className="tu-inventory__brand-grid">
						{INVENTORY_BRANDS.map((brand) => (
							<li key={brand.key}>
								<Link
									href={getBrandHref(brand, linkLocale)}
									className="tu-inventory__brand-card"
									prefetch={false}
								>
									<span className="tu-inventory__brand-name">{brand.label}</span>
									<span className="tu-inventory__brand-arrow" aria-hidden="true">
										→
									</span>
								</Link>
							</li>
						))}
					</ul>
				</section>
			</div>
		</section>
	);
}
